import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/layout"

const IndexPage = ({ data }) => {
  const imgData = data.fileName.childImageSharp.fluid
  const author = "jimin"
  const quote = `Go on your path even if you live for a day.`

  return <Layout imgData={imgData} author={author} quote={quote} />
}

export default IndexPage

export const query = graphql`
  query {
    fileName: file(relativePath: { eq: "jimin1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
